import { web } from "./middleware";

export const PowerStatApi = {
  getPowerStats: (params) =>
    web({ url: "/user/power-score-stats", method: "GET" }, params),
};
